<script>
  import { cart } from "$lib/state/cart";
  import { DELETE_ITEM_FROM_CART_EVENT, dispatchCustomEvent } from "$lib/utils/events";
  import { parsePrice } from "$lib/utils/parsePrice";
  import { onMount } from "svelte";
  // import { klaviyoDeleteProduct } from "$lib/utils/KlaviyoEvents";
  import ImageProduct from "../products/ImageProduct.svelte";
  import ShoppingBagQtyCtrl from "./ShoppingBagQtyCtrl.svelte";
  import {klaviyoDeleteProduct} from "$lib/utils/KlaviyoEvents.js";

  /**@type {import ('$lib/types/gql').CartItemInterface}*/
  export let item;
  export let isMini = false;
  let qty = 1;
  let status = "standby";

  const removeItem = async () => {
    try {
      status = "delete";
      const request = await fetch(`/cart?itemId=${item.uid}`, { method: "DELETE" });
      const response = await request.json();
      status = "standby";
      klaviyoDeleteProduct(item, item.quantity);
      if (request.status === 200) {
        dispatchCustomEvent(DELETE_ITEM_FROM_CART_EVENT, $cart, item.uid);
        cart.set(response.cart);
        return;
      }
      throw new Error(/** @type {any} */ (response));
    } catch (error) {
      console.error(error);
    }
  };

  onMount(() => {
    item;
    console.log(item)
    qty = item.quantity;
  });

  // $:console.log(item)

</script>

<li class:delete={status === "delete"} class:mini={isMini}>
  <div class="image">
    <ImageProduct productImage={item.product?.image?.url} alt={item.product?.image?.label ?? ""} borderRadius={30} />
  </div>
  <p class="name">{item.product?.name ?? "fa"}</p>
  <div class="price-container">
    <p class="price">{parsePrice(item.prices?.row_total_including_tax.currency ?? "GBP", "en-gb", item.prices?.row_total_including_tax.value)}</p>
    <ShoppingBagQtyCtrl bind:qty sku={item.product?.sku ?? ""} {item} bind:isMini />
  </div>
  <button class="delete" on:click={removeItem}>
    <img src="/images/svg/trash.svg" alt="trash" />
  </button>
</li>

<style>
  li {
    width: 100%;
    aspect-ratio: 3.5/1;
    display: grid;
    grid-template-columns: 1fr 1.4fr 30px;
    grid-template-rows: 1fr 1.5fr;
    gap: 10px;
    border: 3px solid var(--orange);
    border-radius: 20px;
    padding: 5px;
    align-items: center;
    font-family: sirenia;
    font-weight: 700;
    justify-items: center;
    overflow: hidden;
    background-color: #fff;
    position: relative;
  }
  li.delete {
    border: 3px solid var(--global);
  }
  li.delete::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(90deg, transparent, transparent 20%, #fb5ca9b2);
    transition: all 0.5s ease;
    transform-style: preserve-3d;
    transform-origin: center;
    opacity: 1;
    animation: delete 1s ease infinite;
  }
  @keyframes delete {
    0%, 50% {
      opacity: 0;
      transform:  translateX(-100%) scale(2);
    }
    100% {
      opacity: 1;
      transform:  translateX(100%) scale(1);
    }
  }
  li.mini {
    width: 95%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 140px 1fr 80px;
    grid-template-rows: 40px 1fr;
    border-radius: 0;
    justify-items: start;
    border: none;
    border-bottom: 1px solid var(--orange);
    aspect-ratio: 5/1;
  }
  button {
    border: none;
    background: none;
  }
  .image {
    grid-row: 1/-1;
    width: 90%;
    aspect-ratio: 1/1;
  }
  button.delete {
    width: 25px;
    height: 25px;
    grid-column: 3/4;
    grid-row: 1/2;
  }
  .mini > button.delete {
    grid-column: 3/4;
    grid-row: 1/2;
    justify-self: end;
    margin-right: 10px;
  }
  .name {
    font-size: 1.9rem;
    color: var(--global);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    line-height: 1;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    overflow: hidden;
    text-wrap: balance;
    padding-left: 5px;
    width: 100%;
    grid-column: 2/3;
    grid-row: 1/2;
  }
  .mini .name {
    font-size: 2.2rem;
    grid-row: 1/2;
  }
  .price-container {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    grid-row: 2/3;
    grid-row: 2/3;
  }
  .mini .price-container {
    flex-direction: row-reverse;
    align-items: flex-start;
    grid-row: 2/3;
    grid-column: 2/4;
  }
  .price {
    font-size: 3.2rem;
    color: var(--orange);
  }
  .mini .price {
    font-size: 3.2rem;
  }

  .delete {
    cursor: pointer;
  }
  @media (max-width: 500px) {
    li {
      aspect-ratio: 3/1;
      grid-template-columns: 110px 1fr 30px;
    }
    .price-container {
      grid-column: 2/4;
    }
  }
  @media (min-width: 768px) {
    li {
      grid-template-columns: 160px 1fr 40px;
      grid-template-rows: 50px 1fr;
      aspect-ratio: 3.5/1;
      border-radius: 50px;
      padding: 10px;
    }
    .price-container {
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    }
    .price {
      font-size: 4.4rem;
    }
    .name {
      -webkit-line-clamp: 1;
      line-clamp: 1;
      font-size: 2.4rem;
    }

    .image {
      height: 100%;
      grid-column: 1/2;
      grid-row: 1/-1;
    }
  }
  @media (min-width: 1024px) {
    li {
      height: auto;
      border-radius: 50px;
      grid-template-columns: 220px 1fr 100px;
      aspect-ratio: 4.8/1;
      gap: 0;
      padding: 0;
    }
  }
  @media (min-width: 1366px) {
    li {
      aspect-ratio: 5.5/1;
      grid-template-rows: repeat(4, 25%);
      grid-template-columns: 220px 1fr 120px;
    }
    .price-container {
      grid-row: 3/4;
    }
    .price {
      font-size: 4.4rem;
    }
    .name {
      grid-row: 2/3;
    }

    button.delete{
      grid-row: 2/3;
    }
  }
</style>
